import axiosInst from "../../Config";

export const GetLifestyleEntries_Api = async (data) =>
  await axiosInst.post("/vozo/patient/lifestyle/get", data);

export const PostLifestyleEntry_Api = async (data) =>
  await axiosInst.post("/vozo/patient/lifestyle/insert", data);

export const GetDietRecommendations_Api = async (data) =>
  await axiosInst.post("/vozo/patient/diet/get", data);

export const DeleteLifestyleEntry_Api = async (data) =>
  await axiosInst.post("/vozo/patient/lifestyle/delete", data);

export const GetLifestyleConfig_Api = async (data) =>
  await axiosInst.post("/vozo/lifestyle/config/get", data);
